import IntegrityRoleGrid from 'components/UserRole';
import {Column} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import useIntegritySettings from '../hook/useIntegritySettings';

type Props = {
  settingsId: number;
};

const IntegritySettingsGrid = ({settingsId}: Props) => {
  const dataSource = useIntegritySettings(settingsId);

  return (
    <IntegrityRoleGrid
      dataSource={dataSource}
      id={['revision']}
      allowIntegrity={false}
      allowActions={false}
      disabledExport={false}
      exportName="Historial-parametros"
      autoWidth={true}
      height={'70vh'}
      style={{overflowX: 'auto', overflowY: 'hidden'}}>
      <Column caption={i18n2._('Revision')} dataField="revision" width={90} />
      <Column caption={i18n2._('Motivo')} dataField="reason" width={220} />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        defaultSortOrder={'desc'}
        dataType="date"
        format="dd/MM/yyyy"
        width={140}
      />
      <Column
        caption={i18n2._('Actualizado por')}
        dataField="updatedBy"
        width={160}
      />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={110} />

      <Column
        caption={i18n2._('Correo remitente')}
        dataField="emailFrom"
        width={220}
      />
      <Column caption={i18n2._('Host SMTP')} dataField="host" width={180} />
      <Column caption={i18n2._('Puerto SMTP')} dataField="port" width={110} />
      <Column
        caption={i18n2._('Usuario SMTP')}
        dataField="smtpUser"
        width={190}
      />
      <Column
        caption={i18n2._('Relé anónimo SMTP')}
        dataField="smtpAnonymous"
        dataType="boolean"
        width={150}
      />
      <Column
        caption={i18n2._('Usar SSL')}
        dataField="useSsl"
        dataType="boolean"
        width={120}
      />
      <Column
        caption={i18n2._('Usar StartTLS')}
        dataField="useStartTls"
        dataType="boolean"
        width={150}
      />

      <Column
        caption={i18n2._('Validar email')}
        dataField="validateEmail"
        dataType="boolean"
        width={130}
      />
      <Column
        caption={i18n2._('Validar dominio')}
        dataField="validateDomain"
        dataType="boolean"
        width={140}
      />
      <Column
        caption={i18n2._('Validar grupo')}
        dataField="validateGroup"
        dataType="boolean"
        width={130}
      />
      <Column caption={i18n2._('Dominio')} dataField="domain" width={180} />
      <Column caption={i18n2._('Grupo HSE')} dataField="hseGroup" width={150} />
      <Column caption={i18n2._('Grupo QA')} dataField="qaGroup" width={150} />
      <Column
        caption={i18n2._('Grupo ITPS')}
        dataField="itpsGroup"
        width={150}
      />
      <Column
        caption={i18n2._('Grupo Entrenador')}
        dataField="trainerGroup"
        width={170}
      />
      <Column
        caption={i18n2._('Grupo Colaborador')}
        dataField="collaboratorGroup"
        width={180}
      />
      <Column
        caption={i18n2._('Servidor LDAP')}
        dataField="serverLDAP"
        width={200}
      />
      <Column
        caption={i18n2._('Vigencia capacitacion (días)')}
        dataField="expirationDaysCapaInicial"
        width={200}
      />
      <Column
        caption={i18n2._('Ruta contenido')}
        dataField="filesContentRoute"
        width={220}
      />
      <Column
        caption={i18n2._('Ruta asistencia')}
        dataField="filesSRegistryRoute"
        width={220}
      />
      <Column caption={i18n2._('URL email')} dataField="emailURL" width={220} />

      <Column
        caption={i18n2._('Req. longitud mínima')}
        dataField="pwdRequireMinLength"
        dataType="boolean"
        width={170}
      />
      <Column
        caption={i18n2._('Longitud mínima')}
        dataField="pwdMinLength"
        width={140}
      />
      <Column
        caption={i18n2._('Req. número')}
        dataField="pwdRequireNumber"
        dataType="boolean"
        width={130}
      />
      <Column
        caption={i18n2._('Req. símbolo')}
        dataField="pwdRequireSymbol"
        dataType="boolean"
        width={130}
      />
      <Column
        caption={i18n2._('Sin secuencias obvias')}
        dataField="pwdDisallowObviousSequences"
        dataType="boolean"
        width={190}
      />
      <Column
        caption={i18n2._('Sin datos usuario')}
        dataField="pwdDisallowUserData"
        dataType="boolean"
        width={170}
      />
      <Column
        caption={i18n2._('Historial habilitado')}
        dataField="enablePasswordHistory"
        dataType="boolean"
        width={170}
      />
      <Column
        caption={i18n2._('Contraseñas en historial')}
        dataField="passwordHistoryCount"
        width={200}
      />
    </IntegrityRoleGrid>
  );
};

export default IntegritySettingsGrid;
